// DA4: validate env FIRST. Importing this module runs the Zod parser; any
// misconfiguration throws before React or Supabase boot.
import '@dukanti/shared/env';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
